import CloseIcon from "@mui/icons-material/Close";
import { DialogTitle, IconButton } from "@mui/material";
import { ReactElement } from "react";
import * as React from "react";

import useText from "../../hooks/use-text";
import { LocalizedStrings, SupportedLanguages } from "../../utils/lang";

type Props = {
  onClose(): void;
};

export default function UploadModalHeader(props: Props): ReactElement {
  const { onClose } = props;

  const { strings } = useText(local);

  return (
    <DialogTitle sx={{ m: 0, p: 2 }}>
      {strings.header}
      <IconButton
        className="absolute right-[8px] top-[8px] text-grey-500"
        onClick={onClose}
      >
        <CloseIcon />
      </IconButton>
    </DialogTitle>
  );
}

type LocalSchema = {
  header: string;
};

const local: LocalizedStrings<LocalSchema, SupportedLanguages> = {
  default: {
    header: "Upload Assets",
  },
};
